"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

var _typeof = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/typeof.js");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _rule = _interopRequireDefault(require("@/api/rule"));

var _crud = _interopRequireWildcard(require("@crud/crud"));

var _RR = _interopRequireDefault(require("@crud/RR.operation"));

var _CRUD = _interopRequireDefault(require("@crud/CRUD.operation"));

var _Pagination = _interopRequireDefault(require("@crud/Pagination"));

var _index = _interopRequireDefault(require("./ruleFactor/index"));

var _methods;

function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var defaultForm = {
  id: null,
  name: null,
  expression: null,
  expressionMemo: null,
  createTime: null,
  updateTime: null
};
var _default = {
  name: 'Rule',
  components: {
    pagination: _Pagination.default,
    crudOperation: _CRUD.default,
    rrOperation: _RR.default,
    RuleFactor: _index.default
  },
  mixins: [(0, _crud.presenter)(), (0, _crud.header)(), (0, _crud.form)(defaultForm), (0, _crud.crud)()],
  cruds: function cruds() {
    return (0, _crud.default)({
      title: '规则',
      url: 'api/rule',
      idField: 'id',
      sort: 'id,desc',
      crudMethod: _objectSpread({}, _rule.default)
    });
  },
  data: function data() {
    return {
      isFirst: true,
      ruleFactorVisable: false,
      ruleFactorTitle: '条件项编辑',
      permission: {
        add: ['admin', 'rule:add'],
        edit: ['admin', 'rule:edit'],
        del: ['admin', 'rule:del']
      },
      rules: {},
      queryTypeOptions: [{
        key: 'name',
        display_name: '规则名称'
      }]
    };
  },
  methods: (_methods = {}, (0, _defineProperty2.default)(_methods, _crud.default.HOOK.beforeRefresh, function () {
    return true;
  }), (0, _defineProperty2.default)(_methods, _crud.default.HOOK.afterToEdit, function () {
    console.log('afterToEdit'); // 加载进度信息
  }), (0, _defineProperty2.default)(_methods, "changeFactor", function changeFactor(ruleId) {
    this.ruleFactorVisable = true;

    var _this = this;

    if (this.isFirst) {
      setTimeout(function () {
        // 延迟加载处理的方法
        _this.$refs.ruleFactor.init(ruleId);

        _this.isFirst = false;
      }, 1000);
    } else {
      _this.$refs.ruleFactor.init(ruleId);
    }
  }), _methods)
};
exports.default = _default;